import React, { Component } from 'react';
import { setHeader } from '../../../util/set-header';
import { fetchBookDetail } from '@/api/book';
import { List, Toast, ActivityIndicator } from 'antd-mobile';
import './index.less'

export default class BookDetail extends Component<any, any> {

    state: any = {
        baseModel: {},
    }

    UNSAFE_componentWillMount() {
        setHeader({ title: '订单详情' })
        this._getData()
    }

    async _getData() {
        const { location } = this.props
        const params = new URLSearchParams(location.search)
        const id = params.get('id')
        if (id === null) {
            Toast.info('id不能为空', 1)
            return
        }

        //let id = '313'//this.props.location.state.id
        const data = await fetchBookDetail(id)
        if (data.data) {
            if (data.data.code === 'SUCCESS') {
                this.setState({ baseModel: data.data })
            } else {
                Toast.info(data.data.msg, 1)
            }
        } else {
            Toast.info('服务器返回格式错误~', 1)
        }

    }

    _setItem(title: string, detail: string) {
        return <div className='item-content'>
            <span className='item-title'>{title}:</span>
            <span className='item-detail'>{detail}</span>
        </div>
    }

    _setRemark(remark: string) {
        return <div className='remark'>{remark}</div>
    }


    render() {
        const { baseModel } = this.state
        const model = baseModel.data
        if (baseModel.code !== 'SUCCESS') {
            return <ActivityIndicator toast />
        }
        return (
            <List className='list-content'>
                {this._setItem('预订公寓', model.store_name)}
                {this._setItem('预订时间', `${model.start_day} 至 ${model.end_day}`)}
                {this._setItem('预订房型', model.room_type_name)}
                {this._setItem('预订单价', model.store_price + '元/天/床')}

                {this._setItem('床位数量', model.reserve_bed_count + '个')}
                {this._setItem('住客姓名', model.renter)}
                {this._setItem('手机号码', model.phone)}
                {this._setItem('最晚到店', model.latest_time)}

                {this._setItem('预订说明', '')}
                {this._setRemark(model.reserve_remark)}
            </List>
        )
    }
}